<script setup lang="ts">
import {
  storeToRefs
} from 'pinia'

import {
  Cascader as ACascader
} from 'ant-design-vue'

import {
  DownOutlined
} from '@ant-design/icons-vue'

import {
  useXmAgentAndIndustryToggleStore
} from '../stores'

const XmAgentAndIndustryToggleStore = useXmAgentAndIndustryToggleStore()

const {
  cascaderProps
} = storeToRefs(XmAgentAndIndustryToggleStore)

const {
  onChange
} = XmAgentAndIndustryToggleStore
</script>

<template>
  <ACascader v-bind="cascaderProps" @change="onChange">
    <a class="ant-cascader-link" @click.prevent>
      Change city
      <DownOutlined />
    </a>
  </ACascader>
</template>


<style lang="less" scoped>
.ant-cascader-link {
  font-size: var(--el-font-size-base);
  color: var(--el-text-color-primary, #0a001f);
}
</style>
